import { useMemo } from 'react';

import classNames from 'classnames';
import { useController, UseFormReturn, useFormContext } from 'react-hook-form';

interface TextareaProps {
  id: string;
  name: string;
  placeholder?: string;
  required?: boolean;
  defaultValue?: string | number;
  rules?: Object;
  label?: string;
  rows?: number;
  maxLength?: number;
  resize?: boolean;
}

const Textarea = ({
  id,
  name,
  placeholder,
  required,
  defaultValue,
  rules,
  label,
  rows,
  maxLength,
  resize = false,
}: TextareaProps) => {
  const form: UseFormReturn = useFormContext();

  const {
    control,
    formState: { errors },
  } = form;
  const { field } = useController({ control, name, rules, defaultValue });

  const error = errors[name];

  const inputClasses =
    'text-base text-landing-dark bg-neutrals-white appearance-none block w-full p-4 border rounded-md transition-all duration-300 outline-none ring-0 placeholder:text-landing-dark/50 focus:outline-none focus:ring-0';

  const inputBorderColors = useMemo(
    () =>
      error
        ? 'focus:border-brand-primary border-brand-primary'
        : 'focus:border-neutrals-white border-neutrals-mid ',
    // eslint-disable-next-line
    [!!error]
  );

  return (
    <div className="mb-4">
      {label && (
        <label htmlFor={id} className="mb-1 text-sm font-normal text-neutrals-white">
          {label}
        </label>
      )}
      <div className="relative">
        <textarea
          className={classNames(`${inputBorderColors} ${inputClasses}`, !resize && 'resize-none')}
          id={id}
          rows={rows || 4}
          placeholder={placeholder}
          required={required}
          maxLength={maxLength}
          {...field}
        />
      </div>
      {errors[name] && (
        <div className="mt-2 text-sm font-extrabold text-status-error">
          {errors[name]?.message?.toString()}
        </div>
      )}
    </div>
  );
};

export default Textarea;
